module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="column column-1 coach-stat-item">\n	'+
((__t=( opponent_name ))==null?'':_.escape(__t))+
'\n</div>\n<div class="column column-2 coach-stat-item">\n	';
 _.each(opp_venues, function(venue) { 
__p+='\n	'+
((__t=( venue.round_id ))==null?'':_.escape(__t))+
'('+
((__t=( venue.venue ))==null?'':_.escape(__t))+
')\n	';
 }) 
__p+='\n</div>\n<div class="column column-3 coach-stat-item">\n	'+
((__t=( avg ))==null?'':_.escape(__t))+
'\n</div>\n<div class="column column-4 coach-stat-item">\n	'+
((__t=( last_3_avg ))==null?'':_.escape(__t))+
'\n</div>\n<div class="column column-5 coach-stat-item ">\n	'+
((__t=( last_3_score ))==null?'':_.escape(__t))+
'\n</div>';
}
return __p;
};
